<template>
  <div class="addPro" v-loading="loading">
    <div class="flex space-between pl10 pr20">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>产品 / 新增产品</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="desc">
      <p>规则说明：</p>
      <p>1、企业须承诺所展示的产品不存在抄袭及侵权情况，如发生侵权纠纷，主办方将立即停止对于该产品的一切展示。并由企业承担相应的法律责任。</p>
      <p>2、产品描述性文字需真实准确，不存在蓄意夸大及虚假情况。</p>
      <p>3、只能从已提交的主要产品中选择图片对应的产品中英文名称。如需增加产品，请返回主要产品模块填写并提交。</p>
    </div>
    <el-row>
      <el-col :span="18" :offset="2">
        <el-form style="margin-top: 30px;" :model="form" :rules="rules" ref="productForm" label-position="right"  label-width="200px">
          <template v-for="(item,ind) in allList">
            <template v-if="item.fieldKey != 'pdtLogo' && item.fieldKey != 'typID' && item.fieldKey != 'pdtName' && item.fieldKey != 'pdtEName'">
              <el-form-item :label="item.fieldName" :key="ind" :prop="item.fieldKey" :rules="rulesFn(item)">
                <el-input  :type=" ( item.fieldKey == 'pdtIntro' ||  item.fieldKey == 'pdtEIntro' ) ? 'textarea': 'text'"  v-model="form[item.fieldKey]" :placeholder='item.fieldHolder'></el-input>
              </el-form-item>
            </template>
            <template v-if="item.fieldKey == 'pdtName'">
              <el-form-item :label="item.fieldName" :prop="item.fieldKey" :rules="rulesFn(item)" :key="ind">
                <el-autocomplete
                  popper-class="my-autocomplete"
                  v-model="form[item.fieldKey]"
                  :fetch-suggestions="querySearchAsync"
                  :placeholder="item.fieldHolder"
                  @select="handleSelect(form[item.fieldKey])"
                ></el-autocomplete>
              </el-form-item>
            </template>
            <template v-if="item.fieldKey == 'pdtEName'">
              <el-form-item :label="item.fieldName" :prop="item.fieldKey" :rules="rulesFn(item)" :key="ind">
                <el-autocomplete
                  popper-class="my-autocomplete"
                  v-model="form[item.fieldKey]"
                  :fetch-suggestions="querySearchAsyncEN"
                  :placeholder="item.fieldHolder"
                  @select="handleSelect(form[item.fieldKey])"
                ></el-autocomplete>
              </el-form-item>
            </template>
            <template v-if="item.fieldKey == 'typID'">
              <el-form-item :label="item.fieldName" :prop="item.fieldKey" :rules="rulesFn(item)" :key="ind">
                <el-select v-model="form[item.fieldKey]" :placeholder="item.fieldHolder" >
                  <el-option :label="val.typName" :value="val.typID" v-for="(val) in classTypeList" :key="val.typID"></el-option>
                </el-select>
              </el-form-item>
            </template>
            <template v-if="item.fieldKey == 'pdtLogo'">
              <el-form-item :label="item.fieldName" :prop="item.fieldKey" :rules="rulesFn(item)" :key="ind">
                <el-input v-model="form[item.fieldKey]" style="display:none"/>
                <Upload :isFaceRead="false" :mediaUrl.sync="form[item.fieldKey]" :typeString = '"P"' />
              </el-form-item>
            </template>
          </template>
          <div class="mz">
            <p>*免责声明</p>
            <p>所有上传内容均由参展企业自主上传，主办方不对其中包含或引用的信息的准确性、可靠性或完整性提供任何明示或暗示的保证。如因上传的文字内容触犯中华人民共和国法律，上传企业应自行承担全部责任。</p>
          </div>
          <el-form-item class="btns">
            <el-button size="medium" type="primary" :style="buttonStyle" @click="onSubmit">提交</el-button>
            <el-button size="medium" @click="back">返回</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import api from '@/api'
import Upload from '@/components/Upload'
import tools from '../../utils/tools.js';
import { validateEnCompany, validateChineseZipCode, validateEmail } from '@/utils/validator'
export default {
  data () {
    return {
      "id": `${this.$route.query.id}` === 'undefined' ? '' : `${this.$route.query.id}`,
      form: {},
      classTypeList:[],
      rules: {},
      allList:[],
      buttonStyle: sessionStorage.getItem('buttonStyle') ? JSON.parse(sessionStorage.getItem('buttonStyle')) : {},
      restaurants: [],
      state: '',
      timeout:  null,
      NamesArray: [],
      ENamesArray: [],
      loading: false
    }
  },
  components: {
    Upload
  },
  mounted() {
    this.getProductType()
    this.getsaasfield()
    this.loadAll()
  },
  methods: {
    loadAll() {
      api.GetPdtInfoDetail().then((res)=>{
        // console.log(res,'GetPdtInfoDetail')
        if(res.data.code =='200' && res.data.data){
          if (res.data.data.pdtNames.length > 0) {
            var CNNames = {}
            res.data.data.pdtNames.map(item => {
              CNNames = {"value": item}
              this.NamesArray.push(CNNames)
            })
          }
          if (res.data.data.pdtENames.length > 0) {
            var ENNames = {}
            res.data.data.pdtENames.map(item => {
              ENNames = {"value": item}
              this.ENamesArray.push(ENNames)
            })
          }
        }
      })
      // if (Lan === 'CN'){
      //   return NamesArray
      // } else{
      //   return ENamesArray
      // } 
    },
    querySearchAsync(queryString, cb) {
      // console.log(queryString,'queryString   130')
      // this.restaurants = this.NamesArray
      var restaurants = this.NamesArray;
      var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 1000 * Math.random());
    },
    querySearchAsyncEN(queryString, cb) {
      // this.restaurants = this.ENamesArray
      var restaurants = this.ENamesArray;
      var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 1000 * Math.random());
    },
    createStateFilter(queryString) {
      return (state) => {
        // console.log(state.value.toLowerCase().indexOf(queryString.toLowerCase()),'state')
        // return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0); // 只显示第一个字相符
        return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0);
      };
    },
    handleSelect(item) {
      // console.log(item);
      // console.log(this.form)
    },
    //获取展品分类
    getProductType(){
      api.searchproducttype().then((res)=>{
        if(res.data.code =='200'){
          var _data = res.data.data
          this.classTypeList = _data
        }
      })
    },
    rulesFn(item){
      var temp = ''
      var rulesData= {
        pdtLogo: [{ required: item.required, trigger: 'change', message: '请'+item.fieldName}],
        other:{required:item.required, message: item.fieldName+'不能为空', trigger: 'change'},
      }
      switch (item.fieldKey){
      case 'pdtLogo':
        temp = item.fieldKey
        break;
      default: 
        temp = 'other'
        break
      }
      return rulesData[temp]
    },
    getsaasfield(){
      api.getsaasfield({type:"product"}).then(res => {
        if (res.data.code === 200) {
          this.allList =[]
          var _data = res.data.data
          for(var i = 0;i<_data.length;i++){
            if(_data[i].enable == 1){
              this.allList.push(_data[i])
            }
          }
          for(var j=0;j<this.allList.length;j++){
            this.$set( this.form,this.allList[j].fieldKey,"")
          }
          this.$nextTick(() => {
            if(this.id !=''){
              api.productinfo({id : this.id}).then((res)=>{
                if(res.data.code =='200'){
                  var _data = res.data.data
                  for (let i in this.form) {
                    this.form[i] = _data[i]?''+_data[i]+'':''
                  }
                }
              })
            }
          })
        }
      })
    },
    changeSelect(val){
      this.form.typID = val
    },
    onSubmit() {
      this.loading = true
      for (let i in this.form) {
        if( typeof this.form[i] != 'object'){
          this.form[i] = (this.form[i]).toString().replace(/^\s+|\s+$/g,"")
        }
      }
      // console.log(this.NamesArray,'222')
      // console.log(this.NamesArray.filter(this.createStateFilter(this.form.pdtName)),'222')
      if (this.form.pdtName !== "" && this.NamesArray.filter(this.createStateFilter(this.form.pdtName)).length === 0) {
        this.form.pdtName = ""
        // console.log(this.form.pdtName,'2221')
      }
      if (this.form.pdtEName !== "" && this.ENamesArray.filter(this.createStateFilter(this.form.pdtEName)).length === 0) {
        this.form.pdtEName = ""
      }
      for(var i = 0;i<keyText.length;i++){
        this.form.pdtName = this.form.pdtName.replace(new RegExp(keyText[i],'g'),'')
        this.form.pdtIntro = this.form.pdtIntro.replace(new RegExp(keyText[i],'g'),'')
      }
      
      // if(this.form.pdtEIntro !== "" || this.form.pdtEName !== "" || this.form.pdtIntro !== "" || this.form.pdtLogo !== "" || this.form.pdtName !== ""){
      if(this.form.pdtEName !== "" || this.form.pdtName !== ""){
        this.$refs['productForm'].validate((valid) => {
          if (valid) {
            var paramt = JSON.parse(JSON.stringify(this.form))
            if(this.id !=''){
              paramt.id = parseInt( this.id)
            }
            paramt.typID = parseInt(this.form.typID) 
            api.saveproduct(paramt).then((res) => {
              if (res.data.code === 200) {
                this.$notify({
                  title: '保存成功',
                  type: 'success'
                })
                // this.$router.go(-1)
                this.$router.push(`/ProductList`)
              }
            })
          } else {
            this.$notify({
              title: '请检查表单填写项是否符合规范！',
              type: 'error'
            })
            this.loading = false
            return false
          }
        })
      } else {
        this.$notify({
          title: '请填写产品中文名称或者产品英文名称！',
          type: 'error'
        })
        this.loading = false
        // this.$router.go(-1)
      }
    },
    back() {
      // this.$router.go(-1)
      this.$router.push(`/ProductList`)
    }
  }
}
</script>
<style lang="less">
.blue {
  color: #409eff;
}

.title {
  margin-bottom: 30px;
}

.col-1-fix {
  padding-left: 0 !important;
}
.desc{
  font-size: 14px;
  line-height: 18px;
  padding: 10px;
}
.mz{
  font-size:14px;
  color:#999;
}
.btns{
  text-align: center;
  padding-top: 15px;
}
.el-autocomplete{
  width: 100%;
}
@media screen and (max-width:540px){
  .addPro{
    .el-form-item__label{
      font-size:14px;
    }
    .el-input--small .el-input__inner{
      border:0;
      text-align: right;
      padding-right: 45px;
    }
    .el-form-item{
      border-bottom: 1px solid #ededed;
    }
    .dash-upload{
      width:180px;
    }
    .noRequire .el-form-item__label::before{
      content: '';
      display: inline-block;
      width:10px;
    }
    .el-form-item__error{
      text-align: right;
      width:100%;
    }
  }
}
</style>
